var React = require('react');

function ArrowUpRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M.4 10.5l10-10M.4.5h10v10"}));
}

ArrowUpRightInline.defaultProps = {"className":"stroke","viewBox":"0 0 10.9 10.9"};

module.exports = ArrowUpRightInline;

ArrowUpRightInline.default = ArrowUpRightInline;
